<template>
  <a>
    <span class="modal-body-text">Normal event scheduling requires 90 days notice, please choose a date that meets these requirements or contact ADURO for assistance scheduling an event sooner.</span>
  </a>
</template>

<script>
export default {
  name: 'submit-all-body-modal'
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// SubmitAllEvent90DaysError.vue?4ca8034b